import { ValidatedTextField } from './validated-text-field.component'
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core'
import { InputMask } from '../common/input-masks/input-mask'

@Component({
    selector: 'MaskedValidatedTextField',
    templateUrl: './html-templates/masked-validated-text-field.component.html'
})
export class MaskedValidatedTextFieldComponent extends ValidatedTextField implements OnChanges {
    @Input() inputMask: InputMask
    @Input() disabled: boolean = false
    @Input() for = ''
    @Input() id = ''

    ngOnInit() {
        this.id = this.id + this.getId();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.text.isFirstChange()) {
            this.text = this.inputMask.mask(this.text)
        } else {
            if (changes.text.previousValue === undefined && changes.text.currentValue !== undefined && changes.text.currentValue !== '') {
                this.text = this.inputMask.mask(this.text)
            }
        }
    }

    getValue() {
        return this.inputMask.unmask(this.text)
    }

    handleChange(newText: string) {
        this.text = newText
        this.onValueChange.emit(this.inputMask.unmask(this.text))
    }

    handleFocus() {
        this.text = this.inputMask.unmask(this.text)
    }

    handleBlur() {
        this.validate()
        this.text = this.inputMask.mask(this.text)
    }

    getDescribedBy(): string | null {
        const ids: string[] = [];
        ids.push(`${this.text.length}-error`);

        return ids.length ? ids.join('') : null;
    }
    getId() {
        const timestamp = Date.now().toString(36)
        const randomStr = Math.random().toString(36).substring(2, 9)
        return `field-${timestamp}-${randomStr}`//return this.id
    }

}
